export const UPDATE_MOBILE_APPS = 'UPDATE_MOBILE_APPS';

export const updateMobileApps = (data) => ({
  type: UPDATE_MOBILE_APPS,
  data,
});